import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { laborHoursConstant } from 'src/redux/actions/constant';
import laborHoursService from 'src/services/apiServices/laborHoursService/laborHoursService';

function* editLaborHours(action: any): SagaReturnType<any> {
  try {
    yield put({ type: laborHoursConstant.EDIT_LABOR_HOURS_LOADER });
    const response = yield call(laborHoursService.editLaborHour, action.payload);
    if (response?.status === 200) {
      yield put({
        type: laborHoursConstant.EDIT_LABOR_HOURS_SUCCESS,
        payload: { response: response.data, status: response?.status },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: laborHoursConstant.EDIT_LABOR_HOURS_FAILURE, payload: error });
  }
}

function* editLaborHoursSaga() {
  yield takeEvery(laborHoursConstant.EDIT_LABOR_HOURS_REQUEST, editLaborHours);
}

export default editLaborHoursSaga;
